/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";
import { ActivityItemConfig } from "./@types";

const fetchActivityItemConfig = async (): Promise<ActivityItemConfig[]> => {
    const { data } = await apiInputService.get("/activitiesItemsConfig");

    return data;
}


export const useActivityItemConfig = (options?: any) => {
    const { subscription } = useSubscription();

    return useQuery<ActivityItemConfig[]>(
        ["activity-item-config", subscription?.subscriptionId],
        () => fetchActivityItemConfig(),
        {
            ...options,
        }
    );
}